
// import React from 'react';
// import '../css/Navbar.css';
// import logo from '../logo/logo.png'
// const Navbar = () => {
//   return (
//     <nav className="navbar">
//       <div className="navbar-container">
//         <div className="navbar-left">
//           <h1 className="navbar-title"># Authentic luxury fragrance decants</h1>
//           <p className="navbar-subtitle">Trusted Since 2017</p>
//           <p className="navbar-subtitle">700+ Happy users</p>
//           <p className="navbar-subtitle">2500+ Orders fulfilled</p>
//         </div>
//         <div className="navbar-right">
//           <div className="logo-container">
//             <img 
//               src={logo} 
//               alt="Brand Logo" 
//               className="navbar-logo"
//             />
//           </div>
//           <div className="google-link-container">
//             <a 
//               href="https://www.google.com" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="google-link"
//             >
//               <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
//                 <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
//                 <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
//                 <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
//                 <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
//               </svg>
//               <span className="google-link-text">Visit Google</span>
//             </a>
//           </div>
//         </div>
//         <button className="mobile-menu-btn">
//           <span className="menu-line"></span>
//           <span className="menu-line"></span>
//           <span className="menu-line"></span>
//         </button>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from 'react';
import '../css/Navbar.css';
import axiosInstance from '../config';


const Navbar = () => {
  const [logoData, setLogoData] = useState(null);
  const [googleLink, setGoogleLink] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchNavbarData();
  }, []);

  const fetchNavbarData = async () => {
    try {
      setLoading(true);
      setError(null);

      console.log('Starting to fetch navbar data...');

      // Fetch logo data
      const logoResponse = await axiosInstance.get('/user/logos');
      console.log('Logo API Response:', logoResponse.data);

      if (logoResponse.data.success && logoResponse.data.data && logoResponse.data.data.length > 0) {
        // Get the first active logo
        const activeLogo = logoResponse.data.data.find(logo => logo.is_active === true);
        console.log('Active Logo Found:', activeLogo);
        
        if (activeLogo) {
          setLogoData(activeLogo);
          console.log('Logo URL to load:', activeLogo.image_url);
        } else {
          console.log('No active logo found');
        }
      } else {
        console.log('No logo data received or API not successful');
      }

      const googleLinkResponse = await axiosInstance.get('/user/google-links');
      console.log('Google Link API Response:', googleLinkResponse.data);

      if (googleLinkResponse.data.status && googleLinkResponse.data.data && googleLinkResponse.data.data.length > 0) {

        const activeGoogleLink = googleLinkResponse.data.data.find(link => link.status === 'active');
        console.log('Active Google Link Found:', activeGoogleLink);
        
        if (activeGoogleLink) {
          setGoogleLink(activeGoogleLink);
        } else {
          console.log('No active Google link found');
        }
      }

    } catch (err) {
      console.error('Error fetching navbar data:', err);
      setError('Failed to load navbar data: ' + err.message);
    } finally {
      setLoading(false);
      console.log('Loading complete');
    }
  };

  const handleImageError = (e) => {
    console.error('Logo image failed to load:', e.target.src);
    e.target.style.display = 'none';
  };

  if (loading) {
    return (
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-left">
            <h1 className="navbar-title"># Authentic luxury fragrance decants</h1>
            <p className="navbar-subtitle">Loading...</p>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <h1 className="navbar-title"># Authentic luxury fragrance decants</h1>
          <p className="navbar-subtitle">Trusted Since 2017</p>
          <p className="navbar-subtitle">700+ Happy users</p>
          <p className="navbar-subtitle">2500+ Orders fulfilled</p>
        </div>
        
        <div className="navbar-right">

          {error && (
            <div style={{ color: 'red', fontSize: '12px', marginRight: '10px' }}>
             {error}
            </div>
          )}
          
          {logoData ? (
            <div className="logo-container">
              <img 
                src={logoData.image_url} 
                alt="Brand Logo" 
                className="navbar-logo"
                onError={handleImageError}
                onLoad={() => console.log('Logo loaded successfully:', logoData.image_url)}
              />
            </div>
          ) : (
            <div className="logo-container" style={{ opacity: 0.5 }}>
              <div className="navbar-logo" style={{
                backgroundColor: '#333',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '12px'
              }}>
                No Logo
              </div>
            </div>
          )}
          
          {googleLink && googleLink.url && (
            <div className="google-link-container">
              <a 
                href={googleLink.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="google-link"
              >
                <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span className="google-link-text">Google Reviews</span>
              </a>
            </div>
          )}
        </div>

        <button className="mobile-menu-btn">
          <span className="menu-line"></span>
          <span className="menu-line"></span>
          <span className="menu-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;